export const EMAIL_TO_SUPPORT_URL = 'mailto:support-team@neo.tax';
